/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable camelcase */

import React from 'react'
import PropTypes from 'prop-types'

import Account from 'common/modules/account'
import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import Plan from 'common/modules/plan'
import Arbiter from 'common/modules/arbiter'
import xFrame from 'common/xFrame'

import { connect } from 'react-redux'
import SelectDonation from '@piconetworks/select-donation'

import { withRouter, Link } from 'common/components/MenuRouterAdapter'
import { colors } from '@piconetworks/functions'
import { Menu, GO_TO_MENU_ROUTE_AND_OPEN, closeMenu } from '@piconetworks/menu-middleware'

import MenuRoutes from '@piconetworks/menu-router'
// import MenuRoutes from 'common/picore/src/packages/MenuRoutes/index'

import WizardRedux from 'common/pkgs/WizardRedux'
import Wizard from 'common/modules/wizard'

import { bindActionCreators } from 'redux'
import style from './styles.module.scss'

class PopupMenu extends React.Component {
    componentDidMount() {
        const { goToMenuRouteAndOpen, menuRoute } = this.props

        if (!menuRoute) {
            goToMenuRouteAndOpen('/')
        }
    }

    render() {
        const {
            linkColor = '',
            showMobileOnly = false,
        } = this.props

        const utmRootUrl = process.env.MARKETING_SITE_URL

        return (
            <div
                className={style.popupMenuContainer}
                style={{ borderTopColor: linkColor }}
            >
                <Menu
                    showMobileOnly={showMobileOnly}
                    MenuToggle={() => (
                        <div />
                    )}
                    routeProps={{ ...this.props, utmRootUrl }}
                    routes={{
                        '/': (routeProps) => <MenuRoutes.Root {...routeProps} />,
                        '/editProfile': (routeProps) => (
                            <MenuRoutes.EditProfile.Root {...routeProps} />
                        ),
                        '/editProfile/editName': (routeProps) => (
                            <MenuRoutes.EditProfile.EditName {...routeProps} />
                        ),
                        '/editProfile/editEmail': (routeProps) => (
                            <MenuRoutes.EditProfile.EditEmail {...routeProps} />
                        ),
                        '/editProfile/editPassword': (routeProps) => (
                            <MenuRoutes.EditProfile.EditPassword {...routeProps} />
                        ),
                        '/editProfile/deleteAccount': (routeProps) => (
                            <MenuRoutes.EditProfile.DeleteAccount {...routeProps} />
                        ),
                        '/manageNewsletters': (routeProps) => (
                            <MenuRoutes.ManageNewsletters.Root {...routeProps} />
                        ),
                        '/managePlan': (routeProps) => {
                            const {
                                currentSubscriptionIdIsGift,
                                monetizationTypeIsDonation,
                                monetizationTypeIsPass,
                                monetizationIsPledge,
                                currentSubscriptionTypeIsSubscription,
                                goToMenuRouteAndOpen,
                            } = routeProps

                            const managePlanIndex = {
                                '/managePlan/gift': () => !!currentSubscriptionIdIsGift,
                                '/managePlan/donation': () => !!monetizationTypeIsDonation,
                                '/managePlan/pass': () => !!monetizationTypeIsPass,
                                // '/managePlan/membership': () => !!monetizationIsPledge,
                                '/managePlan/subscription': () => !!currentSubscriptionTypeIsSubscription || !!monetizationIsPledge,
                            }

                            const menuRoute = Object.keys(managePlanIndex).reduce((acc, key) => {
                                if (managePlanIndex[key]()) {
                                    return key
                                }

                                return acc
                            }, '/')

                            goToMenuRouteAndOpen(menuRoute)

                            return null
                        },
                        // '/managePlan/membership': (routeProps) => (
                        //     <MenuRoutes.ManagePlan.Membership {...routeProps} />
                        // ),
                        '/managePlan/subscription': (routeProps) => (
                            <MenuRoutes.ManagePlan.Subscription.Root
                                {...routeProps}
                            />
                        ),
                        '/managePlan/subscription/stopSubscription': (
                            routeProps,
                        ) => (
                            <MenuRoutes.ManagePlan.Subscription.StopSubscription
                                {...routeProps}
                            />
                        ),
                        '/managePlan/gift': (routeProps) => (
                            <MenuRoutes.ManagePlan.Gift {...routeProps} />
                        ),
                        '/managePlan/subscription/finished': (routeProps) => (
                            <MenuRoutes.ManagePlan.Subscription.Finished
                                {...routeProps}
                            />
                        ),
                        '/managePlan/pass': (routeProps) => (
                            <MenuRoutes.ManagePlan.Pass {...routeProps} />
                        ),
                        '/managePlan/donation': (routeProps) => (
                            <MenuRoutes.ManagePlan.Donation.Root {...routeProps} />
                        ),
                        '/managePlan/donation/change': (routeProps) => (
                            <MenuRoutes.ManagePlan.Donation.Change {...routeProps} />
                        ),
                        '/managePlan/switchPlan': (routeProps) => (
                            <MenuRoutes.ManagePlan.SwitchPlan {...routeProps} />
                        ),
                        '/managePlan/cancelPlan': (routeProps) => (
                            <MenuRoutes.ManagePlan.CancelPlan {...routeProps} />
                        ),
                        '/logOut': (routeProps) => (
                            <MenuRoutes.LogOut.Root {...routeProps} />
                        ),
                        '/notification': (routeProps) => (
                            <MenuRoutes.Notification.Root {...routeProps} />
                        ),
                        '/notification/cancelPlan': (routeProps) => (
                            <MenuRoutes.Notification.CancelPlan {...routeProps} />
                        ),
                        '/notification/keepPlan': (routeProps) => (
                            <MenuRoutes.Notification.KeepPlan {...routeProps} />
                        ),
                        '/notification/switchPlanSuccess': (routeProps) => (
                            <MenuRoutes.Notification.SwitchPlanSuccess {...routeProps} />
                        ),
                    }}
                />
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    const userHasCurrentPurchases = Loader.selectors.userHasCurrentPurchases(state)
    const defaultPopup = Loader.selectors.getDefaultPopup(state)
    return {
        Link,
        account: state.account,
        accountDeleted: state.account.accountDeleted,
        contrastColor: colors.getContrastColor(Loader.selectors.linkColor(state)),
        priceText: Loader.selectors.priceText,
        currentBillingIntervalTotalPaid: Loader.selectors.currentBillingIntervalTotalPaid(state),
        currentProductId: Loader.selectors.currentProductId(state),
        currentProductOptionCurrency: Loader.selectors.currentProductOptionCurrency(state),
        currentPurchaseCanceled: Loader.selectors.currentPurchaseCanceled(state),
        currentPurchaseFailed: Loader.selectors.currentPurchaseFailed(state),
        currentSubscriptionEnd: Loader.selectors.currentSubscriptionEnd(state),
        currentSubscriptionId: Loader.selectors.currentSubscriptionId(state),
        currentSubscriptionIdIsGift: Loader.selectors.currentSubscriptionIdIsGift(state),
        currentSubscriptionStart: Loader.selectors.currentSubscriptionStart(state),
        currentSubscriptionIsTrial: Loader.selectors.currentSubscriptionIsTrial(state),
        currentSubscriptionTypeIsPass:
            Loader.selectors.currentSubscriptionTypeIsPass(state),
        currentSubscriptionTypeIsRecurringDonation:
            Loader.selectors.currentSubscriptionTypeIsRecurringDonation(state),
        currentSubscriptionTypeIsSubscription:
            Loader.selectors.currentSubscriptionTypeIsSubscription(state),
        firstDonation: Loader.selectors.firstDonation(state),
        guestLoader: Loader.selectors.loader(state).guest,
        isGroupAdmin: Loader.selectors.isGroupAdmin(state),
        isGroupMember: Loader.selectors.isGroupMember(state),
        groupName: Loader.selectors.groupName(state),
        linkColor: Loader.selectors.linkColor(state),
        memberNoun: Loader.selectors.memberNoun(defaultPopup),
        memberType: Loader.selectors.memberType(defaultPopup),
        memberVerbPresentParticiple: Loader.selectors.memberVerbPresentParticiple(state),
        monetizationIsPledge: Loader.selectors.monetizationIsPledge(defaultPopup),
        monetizationTypeIsDonation: Loader.selectors.monetizationTypeIsDonation(defaultPopup),
        monetizationTypeIsGroup: Loader.selectors.monetizationTypeIsGroup(defaultPopup),
        monetizationTypeIsPass: Loader.selectors.monetizationTypeIsPass(defaultPopup),
        next: Loader.selectors.next(state),
        nextProductOptionPrice: Loader.selectors.nextProductOptionPrice(state),
        nextStatusNext: Loader.selectors.nextStatusNext(state),
        nextSubscriptionEnd: Loader.selectors.nextSubscriptionEnd(state),
        nextSubscriptionStart: Loader.selectors.nextSubscriptionStart(state),
        nextProductOptionInterval: Loader.selectors.nextProductOptionInterval(state),
        originalEnrollmentDate: Loader.selectors.originalEnrollmentDate(state),
        pricingHasMonetization: Loader.selectors.pricingHasMonetization(defaultPopup),
        publisherId: Loader.selectors.publisherId(state),
        publisherName: Loader.selectors.publisherName(state),
        pubPriceChangeDate: Loader.selectors.pubPriceChangeDate(state),
        supportEmail: Loader.selectors.supportEmail(state),
        topScopeLoader: Loader.selectors.topScopeLoader(state),
        updatePaymentMethodText: Loader.selectors.updatePaymentMethodText(state),
        userAvatarUrl: Loader.selectors.userAvatarUrl(state),
        userEmail: Loader.selectors.userEmail(state),
        userFullName: Loader.selectors.userFullName(state),
        userHasCurrentPurchases,
        userHasGroupData: Loader.selectors.userHasGroupData(state),
        userHasPassword: Loader.selectors.userHasPassword(state),
        userId: Loader.selectors.userId(state),
        userInitials: Loader.selectors.userInitials(state),
        userLoader: Loader.selectors.loader(state).user,
        userVerified: Loader.selectors.userVerified(state),
        menuRoute: state._menu.menuRoute,
        SelectDonation,
        WizardRedux,
        canDeleteAccount: !userHasCurrentPurchases,
        getPlanTexts: (scope) => Loader.selectors.planTexts(state, scope, defaultPopup),
        featureList: (scope) => Loader.selectors.featureList(state, scope),
        isReadyToMount: !state?.loader?.isFetching
            && Loader.selectors.currentProductOptionId(state),
        isFetching: state.loader?.isFetching,
        getScopedLoader: (scope) => Loader.selectors.scopedLoader(state, scope),
        loader: Loader.selectors.loader(state),
        thisWizard: Wizard.selectors.thisWizard({ state, router: props.router }),
        userSyncNewsletters: Loader.selectors.userSyncNewsletters(state),
        wizard: state.wizard,
        currentProductOptionId: Loader.selectors.currentProductOptionId(state),
        updateLoaderUserNewsletters: (args) => Internal.creators.sendMessage({
            payload: {
                target: 'pico_arbiter',
                ...Loader.creators.updateLoaderUserNewsletters(args),
            },
        }),
        queryOverride: {
            utmCampaign: state?.zoid?.tag,
            utmSource: Loader.selectors.publisherName(state),
            utmMedium: process.env.HOSTNAME,
            utmContent: 'PopupMenu',
            rootUrl: process.env.MARKETING_SITE_URL,
        },
    }
}

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({
        deleteAccount: Account.creators.deleteAccount,
        updateLoaderUser: Loader.creators.updateLoaderUser,
        initialize: Account.creators.initialize,
    }, dispatch),
    closeMenu: () => { dispatch(closeMenu()) },
    convertGift: () => {
        xFrame.launcher.openPromptAndHeader({ dispatch, entryRoute: '/convert-gift' })
    },
    update: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Account.creators.update,
        dispatch,
    }),
    cancelPlan: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Plan.creators.cancelPlan,
        dispatch,
    }),
    keepPlan: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Plan.creators.keepPlan,
        dispatch,
    }),
    purchaseSwitch: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Plan.creators.purchaseSwitch,
        dispatch,
    }),
    initialize: () => dispatch(Account.creators.initialize()),
    dispatch,
    sendExternalLink: (payload) => dispatch(Internal.creators.sendMessage({
        payload: {
            target: 'pico_arbiter',
            ...Arbiter.creators.sendExternalLink({
                payload,
            }),
        },
    })),
    onEmailChange: (payload) => {
        dispatch({
            type: GO_TO_MENU_ROUTE_AND_OPEN,
            payload: {
                menuRoute: '/notification',
                text: payload?.text || 'Please check your inbox to verify your new email address.',
                backRoute: '/editProfile',
            },
        })
    },
    onDonationChangeSuccess: () => {
        dispatch({
            type: GO_TO_MENU_ROUTE_AND_OPEN,
            payload: {
                menuRoute: '/notification',
                text: 'Your donation has been updated successfully.',
                backRoute: '/managePlan',
            },
        })
    },
    onNewsletterUpdate: () => {
        dispatch({
            type: GO_TO_MENU_ROUTE_AND_OPEN,
            payload: {
                menuRoute: '/notification',
                text: 'Your newsletter preferences have been successfully updated.',
                backRoute: '/manageNewsletters',
            },
        })
    },
    newsletterSubscribe: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Account.creators.newsletterSubscribe,
        dispatch,
    }),
    goToMenuRouteAndOpen: (menuRoute) => {
        dispatch({
            type: GO_TO_MENU_ROUTE_AND_OPEN,
            payload: {
                menuRoute,
            },
        })
    },
})

PopupMenu.defaultProps = {
    menuRoute: null,
    linkColor: '',
    showMobileOnly: false,
    dispatch: null,
    utmRootUrl: null,
    goToMenuRouteAndOpen: () => { },
}

PopupMenu.propTypes = {
    dispatch: PropTypes.func,
    menuRoute: PropTypes.string,
    linkColor: PropTypes.string,
    showMobileOnly: PropTypes.bool,
    utmRootUrl: PropTypes.string,
    goToMenuRouteAndOpen: PropTypes.func,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PopupMenu))
